/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown>, name: NonNullable<unknown> }} Explorer_Info_Batch_Progress_StatusInputs */

const en_explorer_info_batch_progress_status = /** @type {(inputs: Explorer_Info_Batch_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exporting ${i?.current} of ${i?.total}: ${i?.name}`)
};

const fr_explorer_info_batch_progress_status = /** @type {(inputs: Explorer_Info_Batch_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportation de ${i?.current} de ${i?.total}: ${i?.name}`)
};

const de_explorer_info_batch_progress_status = /** @type {(inputs: Explorer_Info_Batch_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportiere ${i?.current} von ${i?.total}: ${i?.name}`)
};

const it_explorer_info_batch_progress_status = /** @type {(inputs: Explorer_Info_Batch_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esportazione di ${i?.current} di ${i?.total}: ${i?.name}`)
};

const ru_explorer_info_batch_progress_status = /** @type {(inputs: Explorer_Info_Batch_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Экспорт ${i?.current} из ${i?.total}: ${i?.name}`)
};

const es_explorer_info_batch_progress_status = /** @type {(inputs: Explorer_Info_Batch_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportando ${i?.current} de ${i?.total}: ${i?.name}`)
};

const zh_cn2_explorer_info_batch_progress_status = /** @type {(inputs: Explorer_Info_Batch_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在导出 ${i?.total} 中的 ${i?.current}：${i?.name}`)
};

const ja_explorer_info_batch_progress_status = /** @type {(inputs: Explorer_Info_Batch_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} の ${i?.current} をエクスポートしています: ${i?.name}`)
};

const hi_explorer_info_batch_progress_status = /** @type {(inputs: Explorer_Info_Batch_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} में से ${i?.current} का निर्यात: ${i?.name}`)
};

const pt_pt2_explorer_info_batch_progress_status = /** @type {(inputs: Explorer_Info_Batch_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportando ${i?.current} de ${i?.total}: ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Exporting {current} of {total}: {name}" |
*
* @param {Explorer_Info_Batch_Progress_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_progress_status = /** @type {((inputs: Explorer_Info_Batch_Progress_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Progress_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_batch_progress_status(inputs)
	if (locale === "de") return de_explorer_info_batch_progress_status(inputs)
	if (locale === "it") return it_explorer_info_batch_progress_status(inputs)
	if (locale === "ru") return ru_explorer_info_batch_progress_status(inputs)
	if (locale === "es") return es_explorer_info_batch_progress_status(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_batch_progress_status(inputs)
	if (locale === "ja") return ja_explorer_info_batch_progress_status(inputs)
	if (locale === "hi") return hi_explorer_info_batch_progress_status(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_batch_progress_status(inputs)
	return en_explorer_info_batch_progress_status(inputs)
});